@if (car(); as car) {

  <a [routerLink]="routerLink()" [class.history]="car.isHistoryItem" class="wrapper">
    <div class="header d-flex flex-row align-items-center">

      <img [lazyLoad]="car.brand.logo" [alt]="car.brand.name" class="brand-logo"
           defaultImage="/assets/images/logo-placeholder.svg" />

      <div class="content flex-fill d-flex flex-column justify-content-center align-items-start">

        <div class="title">{{ car.heading }}</div>

        @if (car.subHeading) {
          <div class="sub-title">{{ car.subHeading }}</div>
        }

      </div>

    </div>

    <div
      class="details d-flex flex-column flex-sm-row justify-content-sm-start align-items-start align-items-sm-center">

      <div [class.me-2]="isPriceChanged" class="price">

        <span i18n>Ціна: </span>

        @if (formattedPrice) {
          {{ formattedPrice }}<sup>*</sup>
        } @else {
          <ng-container i18n>невідома</ng-container>
        }

      </div>

      @if (isPriceChanged) {
        <div [class.up]="isPriceIncreased" [class.down]="!isPriceIncreased" [ngbTooltip]="priceChangeTooltip"
             class="price-change d-inline-flex flex-row justify-content-start align-items-center mt-1 mt-sm-0">
          <mat-icon [svgIcon]="'custom:price-' + (isPriceIncreased ? 'up' : 'down')" class="icon me-1"></mat-icon>
          <span>{{ isPriceIncreased ? '+' : '-' }} {{ formattedPriceChange }}</span>
        </div>
      }

    </div>

    <div class="image-wrapper">

      <img [class.cover]="!car.isNew" class="image" [lazyLoad]="car.image" [alt]="car.heading"
           defaultImage="/assets/images/car-image-placeholder.svg" />

      @if (!!car.labels.length) {

        <div class="car-labels-list d-inline-flex flex-row justify-content-start align-items-center">

          @for (label of car.labels; track label.text) {
            <div [ngStyle]="{ 'background-color': label.color + '26' }"
                 class="car-label d-inline-flex justify-content-start align-items-center">
              <mat-icon [svgIcon]="label.icon" [ngStyle]="{ 'color': label.color }" class="icon me-1"></mat-icon>
              <span class="text">{{ label.text }}</span>
            </div>
          }

        </div>

      }

    </div>

    @if (!!car.specs?.length) {

      <div class="specs">

        @for (spec of car.specs; track spec.label; let index = $index; let last = $last) {

          @if (!car.isHistoryItem || index < 3) {

            <div [class.is-last]="last" class="spec-row">

              <div class="row">

                <div class="label col">{{ spec.label }}</div>

                <div class="value col-auto">{{ spec.value || '-' }}</div>

              </div>

            </div>

          }

        }

      </div>

    }

    <div class="d-flex flex-row">

      <a [routerLink]="routerLink()" class="btn-more btn btn-primary" i18n>
        Докладніше
      </a>

      <!--<button class="btn btn-outline-primary btn-square ms-3" ngbTooltip="До обраного">
        <mat-icon svgIcon="sax:linear-heart"></mat-icon>
      </button>-->

      @if (comparisonTooltip$ | async; as tooltip) {
        <button (click)="onCompareClick($event)" [class.btn-secondary]="!!(isInComparison$ | async)"
                [class.btn-outline-secondary]="!(isInComparison$ | async)" class="btn btn-square ms-3"
                [ngbTooltip]="tooltip" [title]="tooltip">
          <mat-icon [svgIcon]="!!(isInComparison$ | async) ? 'sax:bold-chart-3' : 'sax:linear-chart-1'"></mat-icon>
        </button>
      }

    </div>

  </a>

}
